class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.sticky-atc__button');
    this.targetButton = document.getElementById(this.dataset.targetButton);
    this.targetAnchor = document.getElementById(this.dataset.targetAnchor);
  }

  connectedCallback() {
    if (!this.targetButton) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    this.observer.observe(this.targetButton);

    if (this.button) {
      this.button.addEventListener('click', () => {
        const scrollTarget = this.targetAnchor || this.targetButton;
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
